import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      d="m21.715 5.967-.927-.926a.986.986 0 0 0-1.389 0l-9.71 9.714L4.6 9.668a.986.986 0 0 0-1.39 0l-.925.926a.986.986 0 0 0 0 1.39l6.704 6.704a.968.968 0 0 0 1.383 0L21.705 7.356a.977.977 0 0 0 .01-1.39Z"
    />
  </svg>
);
export default SvgCheck;
